import React, { useEffect, useState } from "react";

import { CircularProgress, IconButton, Tooltip } from "@mui/material";

import { RefreshIcon } from "../../../components/icons";
import useCoolDown from "../../../hooks/use-cool-down";
import { pushError } from "../../../slices/notifications";
import { useDispatch } from "../../../store";
import {
  CustomDomain,
  useRetryCustomDomainMutation,
} from "../../../store/pomeriumApi";

type ToastState = {
  show: boolean;
  lastError?: string;
};

type RetryCustomDomainButtonProps = {
  readonly: boolean;
  customDomain: CustomDomain;
  organizationId: string;
};
const RetryCustomDomainButton = ({
  readonly,
  customDomain,
  organizationId,
}: RetryCustomDomainButtonProps) => {
  const dispatch = useDispatch();
  const [retry, { isLoading: isRetrying }] = useRetryCustomDomainMutation();
  const { isCoolingDown: isRetryCoolingDown, coolDown: coolDownRetry } =
    useCoolDown();
  const [toastState, setToastState] = useState<ToastState>({ show: false });

  useEffect(() => {
    if (
      toastState.show &&
      toastState.lastError !== customDomain.lastError &&
      customDomain.lastError
    ) {
      dispatch(pushError(customDomain.lastError));
      setToastState({ show: false });
    }
  }, [dispatch, toastState, customDomain.lastError]);

  const handleRetry = () => {
    coolDownRetry(5_000);
    retry({
      organizationId,
      customDomainId: customDomain.id,
    });
    setToastState({ show: true, lastError: customDomain.lastError });
  };

  return customDomain.lastError ? (
    <Tooltip title="Retry Custom Domain">
      <span>
        <IconButton
          size="small"
          disabled={readonly || isRetrying || isRetryCoolingDown}
          onClick={handleRetry}
        >
          {isRetrying || isRetryCoolingDown ? (
            <CircularProgress size={20} />
          ) : (
            <RefreshIcon />
          )}
        </IconButton>
      </span>
    </Tooltip>
  ) : (
    <></>
  );
};
export default RetryCustomDomainButton;
